import { useState } from "react";

const useQueryString = (payload: string) => {
  const [search, setSearch] = useState(new URLSearchParams(payload));
  const [json, setJson] = useState<DynamicJsonTypes>(Object.fromEntries(search));

  return { search, setSearch, json, setJson };
};

export default useQueryString;
